import * as React from "react";

function SvgDebug(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 16.832A9.967 9.967 0 0026 16c-4.54 0-8.373 3.025-9.594 7.17v-9.342a.703.703 0 00-.703-.703h-1.406a.703.703 0 00-.703.703v14.297a8.401 8.401 0 01-5.311-1.881L5.076 29.45a1.875 1.875 0 01-2.652-2.652l3.53-3.529a8.405 8.405 0 01-.798-3.582v-.938H1.914c-1.022 0-1.885-.801-1.913-1.822A1.875 1.875 0 011.875 15h3.281v-3.442L2.424 8.826a1.875 1.875 0 012.652-2.652l3.2 3.201h13.447l3.201-3.2a1.875 1.875 0 012.652 2.65l-2.732 2.733V15h3.28c1.022 0 1.853.816 1.876 1.832zM8.495 6.562a6.562 6.562 0 0113.125 0H8.496z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 34a8 8 0 100-16 8 8 0 000 16zm5.934-8.889h.844c.184 0 .333.15.333.333v1.111c0 .184-.15.334-.333.334h-.844a6.004 6.004 0 01-5.045 5.045v.844c0 .184-.15.333-.333.333h-1.112a.333.333 0 01-.333-.333v-.844a6.004 6.004 0 01-5.045-5.045h-.844a.333.333 0 01-.333-.334v-1.11c0-.185.15-.334.333-.334h.844a6.004 6.004 0 015.045-5.046v-.843c0-.184.15-.333.333-.333h1.112c.184 0 .333.149.333.333v.843a6.004 6.004 0 015.045 5.046zM26.89 29v1.129a4.227 4.227 0 003.24-3.24H29a.333.333 0 01-.333-.334v-1.11c0-.185.149-.334.333-.334h1.129a4.227 4.227 0 00-3.24-3.24V23c0 .184-.15.333-.333.333h-1.112a.333.333 0 01-.333-.333V21.87a4.227 4.227 0 00-3.24 3.24H23c.184 0 .333.15.333.333v1.111c0 .184-.149.334-.333.334h-1.129a4.227 4.227 0 003.24 3.24v-1.13c0-.183.15-.332.333-.332h1.112c.184 0 .333.149.333.333zM26 26.889a.889.889 0 100-1.778.889.889 0 000 1.778z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgDebug;
